<template>
  <div class="content-tab rate-limiting-content">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <div class="group-table">
        <fixed-table class="rate-limiting-table" ref="rateTable" :data="rateList" :use-page="false" :header-height="30">
            <div class="right-header" slot="right-header">
                <column style="width: 10%;">{{$t('menu.port')}}</column>
                <column style="width: 25%;">{{$t('rate.ingress')}}</column>
                <column style="width: 25%;">{{$t('rate.egress')}}</column>
                <column style="width: 40%;">{{$t('rate.config')}}</column>
            </div>
            <template slot="rows" slot-scope="props">
                <div class="link-row">
                    <row class="right" :props="props">
                        <div class="data" style="width: 10%;">{{props.data.key}}</div>
                        <div class="data" style="width: 25%;">{{getCir(props.data.val, 'ingress')}}
                        </div>
                        <div class="data" style="width: 25%;">{{getCir(props.data.val, 'egress')}}
                        </div>
                        <div class="data" style="width: 40%;">
                          <span class="icon-edit" @click="onOpen(props.data)"></span>
                        </div>
                    </row>
                </div>
            </template>
        </fixed-table>
        <RateConfig :selectItem=selectedData :onChange="getRate"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import RateConfig from './RateConfig'

export default {
  name: 'RateLimiting',
  components: {
    fixedTable,
    row,
    column,
    RateConfig
  },
  data () {
    return {
      rateList: [],
      selectedData: null,
      isShowLoading: false
    }
  },
  created: async function () {
    this.getRate()
  },
  methods: {
    ...mapActions(['getIngressRate', 'getEgressRate']),
    getRate: function () {
      this.isShowLoading = true
      let me = this
      this.getIngressRate()
        .then(res => {
          if (res.status === 200) {
            let detail = (res.data)
            let result = detail.result
            this.getEgressRate()
              .then(res => {
                if (res.status === 200) {
                  let detail = (res.data)
                  detail.result.forEach(element => {
                    let num = element.key
                    result[num - 1].val['EgressCir'] = element.val.Cir
                    result[num - 1].val['EgressEnable'] = element.val.Enable
                  })
                  me.rateList = result
                  this.isShowLoading = false
                }
              })
              .catch(error => {
                this.$log.error(error)
              })
          }
        })
        .catch(error => {
          this.$log.error(error)
        })
    },
    getCir: function (value, type) {
      let data = null
      if (type === 'ingress') {
        if (!value.Enable) {
          data = this.$t('rate.noLimit')
        } else {
          data = value.Cir / 1000 + ' Mbps'
        }
      } else {
        if (!value.EgressEnable) {
          data = this.$t('rate.noLimit')
        } else {
          data = value.EgressCir / 1000 + ' Mbps'
        }
      }
      return data
    },
    onOpen: function (data) {
      this.selectedData = data
      this.$modal.show('rate-config-modal')
    }
  }
}
</script>

<style lang="scss" scoped>

.content-tab.rate-limiting-content {
  position: relative;
  .content-body {
    .group-table {
      padding-top: 20px;
      height: 100%;
      .qweb-column, .data {
        text-align: left !important;
        padding-left: 20px !important;
      }
      .edit {
        padding: 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RateLimiting.vue